// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3501":"css/app.6867","6949":"css/admin-app.6867"}[chunkId] + ".css";
};